export const GET_USER_DETAILS = 'rta/header/GET_USER_DETAILS';
export const ON_HEADER_CHANGE = 'rta/home/ON_HEADER_CHANGE';
export const ON_TABLE_MODIFIED = 'rta/home/ON_TABLE_MODIFIED';
export const ON_SUBMIT_CLEAR = 'rta/home/ON_SUBMIT_CLEAR';
export const ON_SUBMIT_ERROR = 'rta/home/ON_SUBMIT_ERROR';
export const ON_SUBMIT = 'rta/home/ON_SUBMIT';